import template from './document.html';
import { DocumentController } from './document.controller';

export const documentComponent = {
  name: 'documentComponent',
  restrict: 'E',
  template,
  controller: DocumentController,
  controllerAs: 'vm',
  bindings: {
    document: '<',
    fileExtension: '<',
    download: '&?',
    onResendDocument: '&',
    ticket: '<',
  },
};
